<div class="card mt-5">

  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h5 class="card-title">{{ texts.participants | localize }}</h5>
      </div>
      <div class="col-auto">
        <button class="btn btn-secondary btn-circle btn-sm" (click)="showAddUsersModal()">
          <i class="fa-sharp fa-solid fa-plus"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body card-body-list">
    <div class="list-group">
      @for (user of projectUsers; track user) {
      <div class="list-group-item">
        <div class="row align-items-center">

          <div class="col-auto">
            <div class="avatar-with-badge">
              <sc-avatar [user]="user"></sc-avatar>
              @if (user.IsManager) {
              <span class="badge badge-pill badge-dark">PM</span>
              }
              @if (user.IsAdmin && !user.IsDecider) {
              <span class="badge badge-pill badge-dark">M</span>
              }
              @if (user.IsDecider && !user.IsAdmin) {
              <span class="badge badge-pill badge-dark">E</span>
              }
              @if (user.IsDecider && user.IsAdmin) {
              <span class="badge badge-pill badge-dark">E/M</span>
              }
            </div>
          </div>

          <div class="col ms-n2">
            @if (user.FirstName || user.LastName) {
            <h6 class="mb-0">{{ user.FirstName }} {{ user.LastName }}
              @if (user.IsManager) {
              <span class="small text-muted fw-normal"> ({{ texts.projectManager | localize }})</span>
              }
              @if (user.IsAdmin && !user.IsDecider) {
              <span class="small text-muted fw-normal"> ({{ texts.moderator | localize }})</span>
              }
              @if (user.IsDecider && !user.IsAdmin) {
              <span class="small text-muted fw-normal"> ({{ texts.decider | localize }})</span>
              }
              @if (user.IsDecider && user.IsAdmin) {
              <span class="small text-muted fw-normal"> ({{ texts.deciderModerator | localize }})</span>
              }
            </h6>
            }
            @else {
            <h6 class="mb-0">{{ texts.notRegistered | localize }}</h6>
            }
            <p class="mb-0 user-mail small text-muted fw-normal">{{ user.EMail }}</p>
          </div>

          <div class="col-auto">
            @if (user.canRemove) {
            <button class="btn btn-secondary btn-sm btn-circle" [title]="texts.removeParticipant | localize"
              [disabled]="user.isRemoving" (click)="remove(user)">
              @if (!user.isRemoving) {
              <i class="fa-sharp fa-regular fa-xmark"></i>
              }
              @else {
              <span class="spinner-border spinner-border-sm"></span>
              }
            </button>
            }
            @else {
            <button class="btn btn-dark btn-sm btn-circle">
              <i class="fa-sharp fa-solid fa-check"></i>
            </button>
            }
          </div>

        </div>
      </div>
      }
    </div>
  </div>

</div>

<sc-modal #modal>
  <sc-modal-header>
    <h5 class="modal-title mb-0">
      <i class="fa-sharp fa-solid fa-users me-3"></i>
      {{ texts.participants | localize }}
    </h5>
  </sc-modal-header>

  <sc-modal-body>
    <div class="row">
      <div class="col-12">
        <input class="form-control form-control-search mb-4" [(ngModel)]="q" (ngModelChange)="searchSoon()"
          [placeholder]="texts.searchPlaceholder | localize" />

      </div>
      <div class="col-12 user-list-container">

        <div class="alert alert-error" role="alert" *ngIf="addError">
          <p class="alert-heading mb-0">{{ addError | localize }}</p>
        </div>

        <button *ngIf="showAddEMail" (click)="addByEMail()" [disabled]="isAddingByEMail"
          class="btn btn-block btn-primary">
          <i class="fa-sharp fa-solid fa-user-plus me-2" *ngIf="!isAddingByEMail"></i>
          <span *ngIf="isAddingByEMail" class="spinner-border spinner-border-sm"></span>
          {{ texts.inviteNewParticipant | localize }}
        </button>

        <p *ngIf="!isSearching && !users?.length && !showAddEMail" class="text-muted">
          {{ texts.noUserFound | localize }}
        </p>

        <sc-user-list [users]="users" (removeUser)="removeUser($event);" (addUser)="addUser($event);"
          [language]="loc.language"></sc-user-list>
      </div>
    </div>
  </sc-modal-body>

  <sc-modal-footer>
    <button class="btn btn-round btn-dark" (click)="modal.complete(null)">{{ texts.ok | localize }}</button>
  </sc-modal-footer>

</sc-modal>

<sc-modal #demoAccountModal>
  <sc-modal-header>
    {{ texts.demoAccountTitle | localize }}
  </sc-modal-header>
  <sc-modal-body>
    <p>
      {{ texts.demoAccountBody | localize }}
    </p>
  </sc-modal-body>
  <sc-modal-footer>
    <button class="btn btn-secondary btn-round" (click)="demoAccountModal.dismiss()">{{ texts.ok | localize }}</button>
  </sc-modal-footer>
</sc-modal>